import React, { useState } from "react";
import { Container, Typography } from "@mui/material";
import { Button } from "@mui/material";
import { Trigger_Funny_Api } from "./api/Trigger_Funny_Api";
import { StaffuseAuth } from "../../security/StaffuseAuth";

function Funny() {
  const { logout } = StaffuseAuth();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  function handleClick(e) {
    e.preventDefault();
    Trigger_Funny_Api(logout);
    setIsButtonDisabled(true);
  }

  // <div
  //   style={{
  //     backgroundColor: "#e5e5e5",
  //     height: "250px",
  //     overflow: "scroll",
  //   }}
  // >
  //   peach
  // </div>;

  return (
    <>
      {localStorage.getItem("Username") === "curtis@investin.org" ||
      localStorage.getItem("Username") === "rebeccaseymour@investin.org" ? (
        <></>
      ) : (
        <></>
      )}
      {localStorage.getItem("Username") === "curtis@investin.org" ||
      localStorage.getItem("Username") === "katherine.tarren@investin.org" ? (
        <></>
      ) : (
        <></>
      )}
      {localStorage.getItem("Username") === "curtis@investin.org" ||
      localStorage.getItem("Username") === "gabi@investin.org" ? (
        <></>
      ) : (
        <></>
      )}
    </>
  );
}

export default Funny;
